import React from "react";
import "../style/f-state-cards.css";
import icon1 from "../../../assets/f-state-icon-1.svg"
import icon2 from "../../../assets/f-state-icon-2.svg"
import icon3 from "../../../assets/f-state-icon-3.svg"
function FStatsCards({ totalSales, redeemedAmount, expiredVouchers }) {
  return (
    <div className="fp-stats-card-container d-flex justify-content-between align-items-center">
      <StatsCard icon={icon1} title={"Total Sales"} price={totalSales} isPrice={true} />
      <StatsCard icon={icon2} title={"Redeemed Amount"} price={redeemedAmount} isPrice={true} />
      <StatsCard icon={icon3} title={"Expired Vouchers"} price={expiredVouchers} isPrice={false} />
    </div>
  );
}

export default FStatsCards;

const StatsCard = ({ icon, title, price, isPrice }) => {
  return (
    <div className="fp-stats-card">
      <div className="d-flex align-items-center gap-2">
        {/* icon */}
        <div className="fp-stats-card-icon-container">
          <img src={icon} alt={title} className="fp-stats-card-icon" />
        </div>
        {/* title and price */}
        <div>
          <p className="fp-stats-card-label">{title}</p>
          <p className="fp-stats-card-price">{isPrice?"AED":""} {price}</p>
        </div>
      </div>
    </div>
  );
};
